import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  id: "kt_aside_menu_wrapper",
  ref: "scrollElRef",
  class: "hover-scroll-overlay-y my-5 my-lg-5",
  "data-kt-scroll": "true",
  "data-kt-scroll-activate": "{default: false, lg: true}",
  "data-kt-scroll-dependencies": "#kt_aside_logo, #kt_aside_footer",
  "data-kt-scroll-height": "auto",
  "data-kt-scroll-offset": "0",
  "data-kt-scroll-wrappers": "#kt_aside_menu"
}
const _hoisted_2 = {
  id: "#kt_header_menu",
  class: "menu menu-column menu-title-gray-800 menu-state-title-primary menu-state-icon-primary menu-state-bullet-primary menu-arrow-gray-500",
  "data-kt-menu": "true"
}
const _hoisted_3 = { class: "menu-item" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", { class: "menu-icon" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "bi bi-calculator fs-3" })
], -1)
const _hoisted_5 = { class: "menu-title" }
const _hoisted_6 = { class: "menu-item" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", { class: "menu-icon" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "bi bi-translate fs-3" })
], -1)
const _hoisted_8 = { class: "menu-title" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "menu-item" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "menu-content" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "separator mx-1 my-4" })
  ])
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_router_link, {
          class: _normalizeClass('menu-link '),
          "active-class": "active",
          to: {name:'bookkeep'}
        }, {
          default: _withCtx(() => [
            _hoisted_4,
            _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.$t('offlineBookkeep')), 1)
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createVNode(_component_router_link, {
          class: "menu-link",
          "active-class": "active",
          to: _ctx.changeLang()
        }, {
          default: _withCtx(() => [
            _hoisted_7,
            _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.translate("asideMenuLang")), 1)
          ]),
          _: 1
        }, 8, ["to"])
      ]),
      _hoisted_9
    ])
  ], 512))
}